import { useParams } from 'react-router-dom'
import { useUser, useUserContext } from '../../../../context/UserProvider'
import { useQuery } from 'react-query'
import { fetchFleetReportDetails, fetchCarByAccountNo } from '../../../../api/api'
import FleetReportDetailsTable from '../components/FleetReportDetailsTable'
import { ExcelExportButton } from '../components/ExcelExporter'
import { excelFleetReportDetailsColumns } from '../components/FleetReportDetailsTable/excelUtils'
import { Select } from '../../../cars/components/V3/_shared/Select'
import { useEffect, useState } from 'react'
import { formatTerms } from '../../../../utils/helpers/helpers.reports'
import type { Car } from '../../../../types'
import { fetchFleetReportTerms } from '../../../../api/api'
import AccountInfo from '../components/FleetReportDetailsTable/AccountInfo'

const FleetReportDetails = () => {
  const user = useUser()
  const { chosenCompany: company, fleetReportTerm } = useUserContext() as any

  const { account } = useParams()
  const [term, setTerm] = useState(fleetReportTerm || '')

  const companyId = company?.id
  const contactId = user?.user?.id

  const { data: termsResponse } = useQuery(['fleetReportTerms', companyId], () => fetchFleetReportTerms(companyId), {
    enabled: !!companyId,
  })

  //@ts-expect-error axios type issue
  const terms = (Array.isArray(termsResponse) ? termsResponse : termsResponse?.data || []) as string[]
  const formattedTerms = formatTerms(terms)

  useEffect(() => {
    if (formattedTerms.length > 0 && term === '') {
      setTerm(formattedTerms[0].value)
    }
    localStorage.setItem('fleetReportTerm', term)
  }, [formattedTerms, term])

  const { data: car } = useQuery(
    ['carByAccountNo', contactId, companyId, account],
    () => fetchCarByAccountNo(contactId, companyId, account),
    { enabled: !!contactId && !!companyId && !!account },
  ) as { data: Car }

  const { data: reportResponse, isLoading } = useQuery(
    ['fleetReportDetails', companyId, account, term],
    () => fetchFleetReportDetails(companyId, account, term),
    { enabled: !!companyId && !!term },
  )

  //@ts-expect-error axios type issue
  const report = (Array.isArray(reportResponse) ? reportResponse : reportResponse?.data || []) as any[]

  const columns = excelFleetReportDetailsColumns()
  const config = {
    columns,
    filename: `Fleet_Detaljer_${account}_${term}.xlsx`,
    sheetName: `Fleet_Detaljer_${account}`,
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4">
        <div className="flex flex-row justify-between items-center">
          <div className="flex flex-col gap-2">
            <span className="text-xl font-medium text-primaryText">Flåtedetaljer</span>
            <AccountInfo car={car} />
          </div>
          <div className="md:hidden">
            <ExcelExportButton data={report} config={config} />
          </div>
        </div>
        <div className="flex flex-row gap-2 w-full md:w-auto md:self-end">
          <div className="flex-1 md:flex-none">
            <Select
              className="h-11 w-full"
              placeholder={'Termin'}
              options={formattedTerms}
              value={term}
              onChange={setTerm}
            />
          </div>
          <div className="hidden md:block">
            <ExcelExportButton data={report} config={config} />
          </div>
        </div>
      </div>
      <FleetReportDetailsTable isLoading={isLoading} data={report} />
    </div>
  )
}

export default FleetReportDetails
